import { IProject, IProjectProgress } from 'holberton-school-intranet-api';
import * as React from 'react';
import { ReactElement } from 'react';

interface IProps {
    project: IProject;
    reviewTypeHumanized: string | null;
    hasManualChecks?: boolean;
    progress?: IProjectProgress;
}

export default function ProjectEncouragement({
    project,
    reviewTypeHumanized,
    hasManualChecks = false,
    progress,
}: IProps): ReactElement {
    const { completion, correctionType } = project;

    // Check if project only has quiz checks using correction_type
    // correction_type can be: 'only_quiz', 'only_auto', 'only_manual', 'auto_and_manual', etc.
    const onlyQuizChecks = correctionType === 'only_quiz';

    let message = reviewTypeHumanized;

    if (completion > 0) {
        // Don't show "Still some tasks to work on!" for quiz-only projects
        if (completion <= 80 && !onlyQuizChecks) {
            message = window.I18n.t('projects.review.still_tasks_to_work_on', 'Still some tasks to work on!');
        } else if (completion < 100) {
            message = window.I18n.t('projects.review.good_job_can_grab_points', 'Good job! You can still grab some points!');
        } else {
            message = window.I18n.t('projects.review.congratulations_made_it', 'Congratulations! You made it!');
        }
    }

    if (!message) {
        return null;
    }

    return <span>{message}</span>;
}
